const viewportRenderProbe = typeof window !== 'undefined'
  && typeof window.__KAIROS_VIEWPORT_RENDER_PROBE__ === 'function'
  ? window.__KAIROS_VIEWPORT_RENDER_PROBE__
  : null;

export const KAIROS_VIEWPORT_RENDER_PROBE_V1 = 'KAIROS_VIEWPORT_RENDER_PROBE_V1';

export const recordViewportRender = (viewportIndex) => {
  if (viewportRenderProbe) viewportRenderProbe(viewportIndex);
};
